import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectElementComponent } from './connect-element/connect-element.component';
import { DisconnectElementComponent } from './disconnect-element/disconnect-element.component';

@NgModule({
  declarations: [ConnectElementComponent, DisconnectElementComponent],
  imports: [CommonModule],
  exports: [ConnectElementComponent, DisconnectElementComponent],
})
export class CustomElementsModule {}
